import { render } from "./PropertyTransfer.vue?vue&type=template&id=e345ea94"
import script from "./PropertyTransfer.vue?vue&type=script&lang=js"
export * from "./PropertyTransfer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__